export enum ENUM_EMAIL_COLLECTION_EVENT {
  SUBSCRIBE = 'SUBSCRIBE',
  CLICK = 'CLICK',
}
